import { getRxjsHttpErrorCode, RxjsHttpErrorResponseBody } from '@/features/core/util/rxjs-http-error-response';

const CREDENTIAL_CONFIGURATION_ERROR_MESSAGE =
  'Die angegebenen Zugangsdaten oder OAuth-Einstellungen sind ungültig. Bitte prüfen Sie die Konfiguration.';

const BAD_OAUTH_SETUP_ERROR_MESSAGE =
  'Die OAuth-Konfiguration des Zielsystems wird nicht unterstützt. Bitte prüfen Sie den Authentifizierungstyp.';

const EXTERNAL_SYSTEM_ERROR_MESSAGE =
  'Das Zielsystem ist aktuell nicht verfügbar. Bitte versuchen Sie es später erneut.';

const CREDENTIAL_CONFIGURATION_ERROR_CODES = [
  'invalid_request',
  'unauthorized_client',
  'invalid_scope',
  'invalid_auth_url',
  'invalid_client',
];
const BAD_OAUTH_SETUP_ERROR_CODES = ['unsupported_response_type'];
const EXTERNAL_SYSTEM_ERROR_CODES = ['server_error', 'temporarily_unavailable'];

/** Returns an empty string for unknown errors so callers can apply their own fallback message. */
export function getOAuthErrorMessage(responseBody: RxjsHttpErrorResponseBody | null): string {
  const errorCode = getRxjsHttpErrorCode(responseBody);

  if (errorCode === undefined) {
    return '';
  }

  if (CREDENTIAL_CONFIGURATION_ERROR_CODES.includes(errorCode)) {
    return CREDENTIAL_CONFIGURATION_ERROR_MESSAGE;
  }

  if (BAD_OAUTH_SETUP_ERROR_CODES.includes(errorCode)) {
    return BAD_OAUTH_SETUP_ERROR_MESSAGE;
  }

  if (EXTERNAL_SYSTEM_ERROR_CODES.includes(errorCode)) {
    return EXTERNAL_SYSTEM_ERROR_MESSAGE;
  }

  return '';
}
